const selectDeviceModelAttributes = state => state.data.deviceModelAttributes

const DeviceModelAttributeDataStoreSelectors = {
  deviceModelAttributes: selectDeviceModelAttributes
}

export default DeviceModelAttributeDataStoreSelectors
